var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-codemirror-wrap",staticStyle:{"position":"relative"}},[_c('textarea')])
}]

export { render, staticRenderFns }